// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__oYeBD","column":"Footer_column__TiMpo","media-boxes":"Footer_media-boxes__iOXJi"};